module.exports = {"id":"194333","name":"Rafał Gikiewicz","rating":"72","photo":"./data/images/photos/3/194333.png","club":{"name":"SC Fribourg","logo":"./data/images/clubs/SCFribourg.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RafałGikiewicz0.json
// module id = 3515
// module chunks = 0